import { IDistrictAllowIpItem, TPayloadUpdateSuccess } from '@/services';
import { mergeListItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IDistrictAllowIpDetailStore,
	TPayloadCreateDistrictAllowIpRequest,
	TPayloadDeleteDistrictAllowIpRequest,
	TPayloadGetDistrictAllowIpListRequest,
	TPayloadGetDistrictAllowIpListSuccess,
	TPayloadUpdateDistrictAllowIpRequest,
} from './district-allow-ip.type';

const initialState = {
	fetching: false,
	list: [] as IDistrictAllowIpDetailStore[],
	total: 0,
	params: {},
};

const districtAllowIpSlice = createSlice({
	initialState,
	name: 'districtAllowIp',
	reducers: {
		/* ---- GET LIST START ---- */
		getDistrictAllowIpListRequest: (
			state,
			_action: PayloadAction<TPayloadGetDistrictAllowIpListRequest>
		) => {
			state.fetching = true;
		},
		getDistrictAllowIpListSuccess: (
			state,
			action: PayloadAction<TPayloadGetDistrictAllowIpListSuccess>
		) => {
			const { list } = action.payload;
			state.fetching = false;
			state.list = list;
			state.total = list?.length;
		},
		getDistrictAllowIpListFailure: (state) => {
			state.fetching = false;
		},
		/* ---- GET LIST END ---- */

		/* ---- CREATE START ---- */
		createDistrictAllowIpRequest: (
			state,
			_action: PayloadAction<TPayloadCreateDistrictAllowIpRequest>
		) => {
			state.fetching = true;
		},
		createDistrictAllowIpSuccess: (state) => {
			state.fetching = false;
		},
		createDistrictAllowIpFailure: (state) => {
			state.fetching = false;
		},
		/* ---- CREATE END ---- */

		/* ---- DELETE START ---- */
		deleteDistrictAllowIpRequest: (
			state,
			_action: PayloadAction<TPayloadDeleteDistrictAllowIpRequest>
		) => {
			state.fetching = true;
		},
		deleteDistrictAllowIpSuccess: (
			state,
			action: PayloadAction<{ ids: number[] }>
		) => {
			state.fetching = false;
			state.list = state.list.filter(
				(item) => !action.payload.ids.includes(item.id)
			);
		},
		deleteDistrictAllowIpFailure: (state) => {
			state.fetching = false;
		},
		/* ---- DELETE END ---- */

		/* ---- UPDATE START ---- */
		updateDistrictAllowIpRequest: (
			state,
			_action: PayloadAction<TPayloadUpdateDistrictAllowIpRequest>
		) => {
			state.fetching = true;
		},
		updateDistrictAllowIpSuccess: (state) => {
			state.fetching = false;
		},
		updateDistrictAllowIpFailure: (state) => {
			state.fetching = false;
		},
		/* ---- UPDATE END ---- */

		/** UPDATE LIST SUCCESS (for inline edit) */
		updateDistrictAllowIpListSuccess: (
			state,
			action: PayloadAction<TPayloadUpdateSuccess<IDistrictAllowIpItem>>
		) => {
			const { data } = action.payload;
			const list = [...state.list];
			state.list = mergeListItemUpdated<
				IDistrictAllowIpDetailStore,
				IDistrictAllowIpItem
			>(list, data);
		},

		resetState: () => initialState,
	},
});

export const DistrictAllowIpSelectors = {
	selectFetching: (state: RootState) => state.districtAllowIp.fetching,
	selectList: (state: RootState) => state.districtAllowIp.list,
	selectTotal: (state: RootState) => state.districtAllowIp.total,
	selectParams: (state: RootState) => state.districtAllowIp.params,
};

export const DistrictAllowIpActions = districtAllowIpSlice.actions;
export const DistrictAllowIpReducer = districtAllowIpSlice.reducer;
